var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNlpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nlp-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy",
    transform: "translate(-128, -486)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "healthcare-nlp-api-svgrepo-com",
    transform: "translate(134, 495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6009316,20.756602 C10.2116353,19.7337737 13.9823477,21.7986299 15.0177003,25.3656562 C16.0530529,28.9326823 13.9629129,32.6577816 10.3522092,33.6806099 C9.15125776,34.0208112 7.94088478,34.0124768 6.80565888,33.7336127 L6.43014947,33.6307455 L2.85638332,40 L0.482854548,38.7002468 L4.05286942,32.3180682 C3.07624098,31.4897784 2.31807082,30.3898044 1.93544052,29.0715557 C0.900087888,25.5045294 2.99022788,21.7794303 6.6009316,20.756602 Z M26.5384615,34.9565789 L26.5384615,38.4522368 L19.4615386,38.4522368 L19.4615386,34.9565789 L26.5384615,34.9565789 Z M33.6153846,27.965263 L33.6153846,31.4609209 L19.4615386,31.4609209 L19.4615386,27.965263 L33.6153846,27.965263 Z M12.4012483,26.106836 C11.7822875,23.9743748 9.50975998,22.72993 7.35118711,23.3414037 C5.19261425,23.952877 3.93293167,26.1979146 4.55189246,28.3303757 C5.17085328,30.4628371 7.44338082,31.7072816 9.60195368,31.0958082 C11.7605265,30.4843349 13.0202091,28.2392973 12.4012483,26.106836 Z M40.6923077,20.9739472 L40.6923077,24.4696051 L19.4615386,24.4696051 L19.4615386,20.9739472 L40.6923077,20.9739472 Z M46,13.9826315 L46,17.4782895 L0,17.4782895 L0,13.9826315 L46,13.9826315 Z M46,6.99131576 L46,10.4869737 L0,10.4869737 L0,6.99131576 L46,6.99131576 Z M21.3413463,0 L21.3413463,3.49565789 L5.30769231,3.49565789 L5.30769231,0 L21.3413463,0 Z M40.6923077,0 L40.6923077,3.49565789 L24.6586537,3.49565789 L24.6586537,0 L40.6923077,0 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNlpIcon);
export default __webpack_public_path__ + "static/media/nlp-icon.9504f6e1abd02299eac4e1f9cbf843d0.svg";
export { ForwardRef as ReactComponent };